import { Approve, TrashTopic, MarkAsSpam } from './BulkActions'
import {
  createAuthorColumn,
  createPostColumn,
  createPublishDateColumn,
  createPublishedInColumnForContent
} from './Columns'
import { getPendingContent } from './service'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'

const PendingOverview = () => {
  const COLUMNS = [
    createPostColumn(),
    createPublishedInColumnForContent(),
    createAuthorColumn(),
    createPublishDateColumn()
  ]
  const BULK_ACTIONS = [Approve, MarkAsSpam, TrashTopic]

  return (
    <Overview
      type='pending'
      headerTitle='Pending'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={COLUMNS}
      dataSource={getPendingContent}
      entity='posts'
      bulkActions={BULK_ACTIONS}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_spam.png`}
          header='All done!'
          text='There are no more pending posts'
          button={{ link: '/overview', text: 'Go to content overview' }}
        />
      }
    />
  )
}

export default PendingOverview
